import { isEqual } from 'lodash';
import { timesOverlap } from '../../../lib/dates';
import expandedTimeplanUnits from '../../../entities/TimeplanUnit/expandedTimeplanUnits';

/**
 *
 * @param timeplanUnits Immutable List
 * @returns {*}
 * @private
 */
export default function findOverlapping(timeplanUnits) {
  const expandedTimeplanUnitsSet = expandedTimeplanUnits(timeplanUnits, true);
  return expandedTimeplanUnitsSet
    .reduce((overlaps, timeplanUnit) => {
      const foundOverlaps = expandedTimeplanUnitsSet.filter((matchingTimeplanUnit) => {
        // TODO: Should be identifier?
        if (isEqual(timeplanUnit, matchingTimeplanUnit)) {
          return false;
        }

        const sameDate = timeplanUnit.date === matchingTimeplanUnit.date;
        const sameResource = timeplanUnit.resourceId === matchingTimeplanUnit.resourceId;

        return sameDate
          && sameResource
          && timesOverlap(
            timeplanUnit.from,
            timeplanUnit.to,
            matchingTimeplanUnit.from,
            matchingTimeplanUnit.to,
          );
      });

      if (foundOverlaps.length > 0) {
        const id = timeplanUnit.sourceId || timeplanUnit.id;
        return {
          ...overlaps,
          [id]: foundOverlaps,
        };
      }

      return overlaps;
    }, {});
}
